module.exports = __webpack_public_path__ + "static/media/pool.0efdbc42.mov";